<template lang="pug">
    v-dialog(v-if="isValidIntegrationAppointment" v-model='dialog' scrollable persistent max-width='600px')
        template(v-slot:activator='{ on }')

            v-btn(color="error" small dark v-on="on")
                v-icon mdi-cancel
                | Cancel

        v-card(width="100%" height="475px")
            v-card-text.text-center
                v-container
                    span.text-center.text-h6 {{`Cancel appointment for ${this.currentCampaignCustomer.customer.full_name}`}}

                v-card.mt-4(min-height="1px")
                    TableSimple(
                        dark
                        :items="[integrationAppointment]"
                    )
                        template(v-slot:th-default)
                            th.white--text Date/Time
                        template(v-slot:tr-default="slotProps")
                            td.text-left.xs-width
                                | {{ slotProps.item.friendly_appointment_date_with_time_zone || "---" }}
                v-divider
                v-container.mt-4
                    v-row
                        v-col(cols='12')
                            v-text-field(
                                label='*Cancellation reason'
                                v-model="cancelForm.cancelReason"
                                type='text'
                                clearable
                                required
                                :rules="[rules.required]"
                            )
                        v-col(cols='12')
                            v-checkbox(
                                v-model="cancelForm.doNotNotifyCustomer"
                                label="Do Not Notify Customer"
                            )



            v-card-actions.d-flex.justify-end
                    v-btn.ma-2(color="primary" small outlined ripple @click="unselectDispositionAppointment(); closeDialog()")
                        v-icon mdi-close
                        | Close
                    v-btn.ma-2(:loading="isCanceling" :disabled="!cancelButtonEnabled" color="error" small outlined ripple @click="cancelIntegrationAppointment()")
                        v-icon mdi-cancel
                        | Confirm Cancelation


</template>

<script lang="ts">
    import Vue from 'vue';
    //Component
    import TableSimple from '@/components/shared/tables/table_simple.vue'

    //Data
    import { CancelIntegrationAppointment } from "@/data";

    //Helpers
    import { titleize } from "@/helpers/general";

    export default Vue.extend({
        data() {
            return {
                dialog: false,
                isCanceling: false, 
                cancelForm: {
                    cancelReason: null,
                    doNotNotifyCustomer: false,
                },
                rules: {
                    required: v => !!v || 'Required',
                },
            }
        },
        methods: {
            cancelIntegrationAppointment(){
                if (!(this.currentCampaignCustomer?.campaign_customer_id > 0)) {
                    return;
                }
                if (!(this.integrationAppointment?.appointment_sid?.length > 0)) {
                    return;
                }

                const options = {
                    appointment_id: this.integrationAppointment?.appointment_id || 0,
                    organization_id: this.currentCampaignCustomer?.organization_id || 0,
                    integration: this.currentIntegration || "",
                    campaign_customer_id: this.currentCampaignCustomer?.campaign_customer_id || 0 ,
                    cancel_reason: this.cancelForm?.cancelReason || "",
                    do_not_notify_customer: this.cancelForm?.doNotNotifyCustomer || false,
                };

                this.isCanceling = true; 
                
                CancelIntegrationAppointment(this.integrationAppointment.appointment_sid, options).then((response) => {
                    if (response?.Data?.ok === true) {
                        this.showSnackbar("success", "Successfully canceled " + (titleize(this.currentIntegration) || "integration") + " Appointment");
                        this.displayDetailsView();
                        this.handleCancelIntegrationAppointment(this.integrationAppointment);
                        this.handleCloseDetailsOnCancel();
                        this.closeDialog();
                        if (response?.Data?.volie_appointment_id > 0) {
                            this.selectDispositionAppointmentForCancel(response.Data.volie_appointment_id);
                        }
                    } else {
                        if (response?.Data?.api_status > 0){
                            this.setIntegrationError(response.Data.api_status);
                            this.closeDialog();
                        }
                        let err = "Unable to update this " + (titleize(this.currentIntegration) || "integration") + " Appointment";
                        if (response?.Error?.length > 0) {
                            err = response.Error;
                        }
                        this.showSnackbar("error", err);
                        
                    }
                    this.isCanceling = false; 
                });
            },
            closeDialog(){
                this.dialog = false;
            },
            selectDispositionAppointmentForCancel(appointmentId){
                const appointmentDetails = {
                    appointment_id: appointmentId || 0,
                    action: "cancel",
                }

                this.setIntegrationAppointmentDetails(appointmentDetails)
            },
            unselectDispositionAppointment(){
                //Set appointment id to 0 so watcher unselects disposition in customer_profile -> appointmentDetails
                const appointmentDetails = {
                    appointment_id: 0,
                }
                this.setIntegrationAppointmentDetails(appointmentDetails);
            },
            titleize(string) {
                return titleize(string);
            }
        },
        computed: {
            isValidIntegrationAppointment(){
                return this.integrationAppointment?.appointment_sid?.length > 0;
            },
            cancelButtonEnabled(){
                return this.cancelForm?.cancelReason?.length > 0;
            },
        },
        components: {
            TableSimple
        },
        props: {
            convertAppointmentDateTimeFromMilliseconds: Function, 
            currentCampaignCustomer: Object,
            currentIntegration: String,
            displayDetailsView: Function,
            getIntegrationAppointments: Function,
            handleCancelIntegrationAppointment: Function,
            handleCloseDetailsOnCancel: Function, 
            setIntegrationAppointmentDetails: Function,
            setIntegrationError: Function,
            showSnackbar: Function,
            integrationAppointment: Object,
        }
    });
</script>

<style lang="scss" scoped>
.cancel-container {
    width: 100%;
    height: 100%;
    background-color: white;
    padding: 20px;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
}
</style>
